import React from 'react';
import './MenuScroll.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCar, faCartShopping, faListCheck, faPhotoFilm, faUmbrellaBeach } from "@fortawesome/free-solid-svg-icons";
import { Outlet, Link } from "react-router-dom";


interface Name {

}



const MenuScroll: React.FC<Name> = () => {


    return (
        <div id="navigation">
            <ul>
                <li ><Link to='../' id='wyjazdy'><FontAwesomeIcon id='faCar' icon={faCar} />Wyjazdy</Link> </li>
                <li><Link to='/ToDo'><FontAwesomeIcon id='faListCheck' icon={faListCheck} />Do zrobienia</Link> </li>
                <li><Link to='/ShoppingList'><FontAwesomeIcon id='faCartShopping' icon={faCartShopping} />Lista zakupów</Link></li>
                <li><Link to='/Holiday'><FontAwesomeIcon id='faUmbrellaBeach' icon={faUmbrellaBeach} />Urlop</Link> </li>
                <li><Link to='/Photo'><FontAwesomeIcon id='faPhotoFilm' icon={faPhotoFilm} />Zdjęcia</Link> </li>
            </ul>
            <Outlet />
        </div>
    )
}

export default MenuScroll;